
export const setSolutions = solutions => {
    return { type: "SET_SOLUTIONS", solutions }
}

export const setLoading = value => {
    return { type: "SET_LOADING", value}
}